import { useState } from "react";
import { classNames } from "primereact/utils";
import styles from "./FaqAccordion.module.scss";
import { IFaqItem } from "./models/faqModels";

interface IFaqAccordionProps {
  items: IFaqItem[];
}

export const FaqAccordion = ({ items }: IFaqAccordionProps) => {
  const [openId, setOpenId] = useState<string | null>(null);

  const toggle = (id: string) =>
    setOpenId((current) => (current === id ? null : id));

  return (
    <div className={styles.accordion}>
      {items.map((item) => {
        const isOpen = item.id === openId;

        return (
          <div key={item.id} className={styles.item}>
            <button
              type="button"
              className={styles.header}
              aria-expanded={isOpen}
              onClick={() => toggle(item.id)}
            >
              <span className={styles.question}>{item.question}</span>
              <i
                className={classNames("pi pi-chevron-down", styles.chevron, {
                  [styles.chevronOpen]: isOpen,
                })}
              />
            </button>

            {/* Panels stay mounted; the open/close is a grid-template-rows
                transition on a class toggle, so when switching items the
                closing and opening panels animate at the same time. */}
            <div
              className={classNames(styles.panel, {
                [styles.panelOpen]: isOpen,
              })}
            >
              <div className={styles.panelInner}>
                <div className={styles.answer}>{item.answer}</div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
